// This is used in Comic to create a batch job and start processing
import { FrameRate, RotationOffsets } from '../types';
import apiRequest from './apiRequest';

export type Axis = 'X' | 'Y' | 'Z';

export type ExportType =
  | 'bvh'
  | 'fbx-blender'
  | 'fbx-maya'
  | 'fbx-unreal'
  | 'fbx-roblox'
  | 'glb'
  | 'ma'
  | 'mb';

export type KeyframeCleaningMethod = 'none' | 'reduce' | 'simplify';

export type ExportSettings = {
  characterID: string;
  exportType: ExportType;
  forward: Axis;
  frameRate: FrameRate;
  frameStepSize: number;
  moveInPlace: boolean;
  up: Axis;
  faceExpression?: string;
  handPose?: string;
  ikFeet?: boolean;
  ikHands?: boolean;
  includeMesh?: boolean;
  keyframeCleaning?: KeyframeCleaningMethod;
  rotationOffsets?: RotationOffsets;
  skinHex?: string;
};

type MotionFromVideoPayload = {
  batchName?: string;
  comicModel?: 'comic3' | 'comic4';
  createdByUser?: string;
  exportSettings: ExportSettings;
  facialCapture?: boolean;
  mediaIDs: string[];
  numPeople?: number;
  subscribers?: string[];
};

type MotionFromVideoResponse = {
  batchID: string;
  status: 'VALIDATING' | 'QUEUED' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
  type: 'COMIC';
  emailSubscribers: string[];
  exportSettings: ExportSettings;
  numTotalJobs: number;
  estimatedSecondsWaitTime: number;
  createdAt: string;
  createdBy: string;
};

export default async function postMotionFromVideo(
  payload: MotionFromVideoPayload,
  apiKey: string,
) {
  return await apiRequest<MotionFromVideoResponse>(
    'external-mogen',
    '/motion/fromVideo',
    {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'x-api-key': apiKey,
      },
    },
  );
}
